module.exports = __webpack_public_path__ + "img/0Q3A3452_L_WoodMatted.e1ac6f8d.jpg";